module.exports = __webpack_public_path__ + "static/media/din.891cb993.svg";